import useFormatMessage from '@hooks/useFormatMessage'
import ErrorBase from '@components/ErrorBase'

/**
 * NotAuthorized component displays an error message when the user is not authorized to view a page.
 *
 * @param {object} props - The component props.
 * @param {Error|string} props.error - The error object or message.
 * @param {function} props.resetErrorBoundary - Function to reset the error boundary.
 * @returns {JSX.Element} The NotAuthorized component.
 */
export default function NotAuthorized({ error, resetErrorBoundary }) {
  const formatMessage = useFormatMessage()

  return (
    <ErrorBase
      title={formatMessage('error.notAuthorized.title')}
      subtitle={formatMessage('error.notAuthorized.message')}
      code={401}
      error={error}
      reset={resetErrorBoundary}
    />
  )
}
